export const SITE_LOADING = 'COMMON/SITE_LOADING';

export const NOT_FOUND = 'COMMON/NOT_FOUND';
export const RESET_NOT_FOUND = 'COMMON/RESET_NOT_FOUND';

export const NETWORK_ERROR = 'COMMON/NETWORK_ERROR';
export const RESET_NETWORK_ERROR = 'COMMON/RESET_NETWORK_ERROR';

export const SET_ACTIVE_PAGE = 'COMMON/SET_ACTIVE_PAGE';
export const RESET_ACTIVE_PAGE = 'COMMON/RESET_ACTIVE_PAGE';

export const UPDATE_DEVICE = 'COMMON/UPDATE_DEVICE';

export const FETCH_CURRENCIES_SUCCESS = 'COMMON/FETCH_CURRENCIES_SUCCESS';
export const FETCH_CURRENCIES_ERROR = 'COMMON/FETCH_CURRENCIES_ERROR';
export const CLEAR_FETCH_CURRENCIES = 'COMMON/CLEAR_FETCH_CURRENCIES';

export const ACTION_SUCCESS_NOTIFICATION = 'COMMON/ACTION_SUCCESS_NOTIFICATION';
export const ACTION_ERROR_NOTIFICATION = 'COMMON/ACTION_ERROR_NOTIFICATION';
export const CLEAR_ACTION_NOTIFICATION = 'COMMON/CLEAR_ACTION_NOTIFICATION';

export const SET_LAST_PATCHED_ID = 'COMMON/SET_LAST_PATCHED_ID';
export const RESET_LAST_PATCHED_ID = 'COMMON/RESET_LAST_PATCHED_ID';
